import { useShowEpicPanel } from '@atlassian/jira-software-view-settings/src/controllers/index.tsx';
import { createRouterSelector } from '@atlassian/react-resource-router';
import { parseSearchQuery } from '@atlassian/jira-software-view-settings/src/common/utils/index.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import { useBacklogSelector } from '../index.tsx';
import { getShowEpicAsPanel } from '../selectors/config/index.tsx';

const useLocationSelector = createRouterSelector((state) => state.location);

export const useIsEpicPanelOpen = () => {
	const showEpicAsPanel = useBacklogSelector(getShowEpicAsPanel);
	const isEpicsOpen = useShowEpicPanel();

	// eslint-disable-next-line react-hooks/rules-of-hooks
	const location = fg('optimise_display_epics_panel') ? useLocationSelector() : undefined;
	// drop location check once `optimise_display`_epics_panel` is cleaned up
	const isEpicsOpenFromUrl = fg('optimise_display_epics_panel')
		? location && parseSearchQuery(location.search).EPIC_PANEL
		: undefined;

	// epic panel is set to be open from URL - use that information directly to optimise VC
	if (isEpicsOpenFromUrl === true) {
		return true;
	}

	if (!showEpicAsPanel) {
		return false;
	}
	return isEpicsOpen;
};
